import { SVG, IconProps } from "../SVG";
import React from "react";

export const SpotShield = (props: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <path
            fill="#C9DBFE"
            d="M4.857 17.78c1.738-5.087 7.916-9.787 13.373-11.594 5.482-1.818 11.979-.362 16.283 3.888 4.304 4.25 6.402 10.611 5.107 15.97-1.26 5.374-5.757 8.608-9.715 10.583-3.983 1.985-7.428 1.992-11.538.997-4.123-.96-8.301-2.541-10.448-6.26-2.147-3.72-4.824-8.487-3.062-13.584Z"
        />
        <path
            stroke="#13126C"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.2}
            d="m25.678 14.427-7.803 7.626-3.546-3.466m19.006-1.995c0 8.664-5.111 16.482-13.334 20.074-8.222-3.592-13.333-11.41-13.333-20.074v-9.93c9.556-4.438 18.222-4.438 26.667 0v9.93Z"
        />
    </SVG>
);
SpotShield.displayName = "SpotShield";
